import type { AssignableDeviceRole } from "./devices-api";

export interface DeviceRoleOption {
	value: AssignableDeviceRole;
	label: string;
	requiresPharmacy: boolean;
}

/** Role assignable przy zatwierdzaniu / edycji urządzenia (SSoT z backendem). */
export const DEVICE_ROLE_OPTIONS: DeviceRoleOption[] = [
	{ value: "pharmacy_workstation", label: "Apteka (stanowisko apteczne)", requiresPharmacy: true },
	{ value: "franchise", label: "Franczyza", requiresPharmacy: true },
	{ value: "franchise_managed", label: "Franczyza-obsługiwana", requiresPharmacy: false },
	{ value: "franchise_other", label: "Franczyza — inne", requiresPharmacy: false },
	{ value: "server", label: "Serwer (OCI / infrastruktura)", requiresPharmacy: false },
	{ value: "office_laptop", label: "Laptop biurowy", requiresPharmacy: false },
	{ value: "natubay", label: "Natubay", requiresPharmacy: false },
	{ value: "it_admin", label: "IT (administrator)", requiresPharmacy: false },
];

export const ASSIGNABLE_DEVICE_ROLES = new Set<string>(DEVICE_ROLE_OPTIONS.map((o) => o.value));

/** Role które MOGĄ nieść aptekę (pokazujemy picker scope): stanowisko apteczne +
 * obie franczyzy. SSoT z backendem (`role_is_pharmacy_bound`). */
export function roleAllowsPharmacy(role: string): boolean {
	return role === "pharmacy_workstation" || role === "franchise" || role === "franchise_managed";
}

/** Role gdzie apteka jest OBOWIĄZKOWA (blokuje zapis bez wyboru). Węższe niż
 * `roleAllowsPharmacy`: franczyza-obsługiwana może zostać bez apteki (idfirm NULL).
 * SSoT z backendem (`role_requires_pharmacy`). */
export function roleRequiresPharmacy(role: string): boolean {
	return role === "pharmacy_workstation" || role === "franchise";
}

/** Krótkie etykiety na chipy filtra sekcji — pełne nazwy nie mieszczą się w pasku. */
export const DEVICE_SECTION_SHORT_LABELS: Record<string, string> = {
	pharmacy_workstation: "Apteki",
	franchise: "Franczyza",
	franchise_managed: "Franczyza obsł.",
	franchise_other: "Franczyza inne",
	server: "Serwery",
	office_laptop: "Laptopy",
	natubay: "Natubay",
	it_admin: "IT",
};

/** Kolejność sekcji w widoku kafelków — każda rola to osobna grupa. */
export const DEVICE_ROLE_SECTIONS: {
	role: AssignableDeviceRole | "other";
	label: string;
	subGroupByPharmacy: boolean;
}[] = [
	{ role: "pharmacy_workstation", label: "Apteki", subGroupByPharmacy: true },
	{ role: "franchise", label: "Franczyza", subGroupByPharmacy: true },
	{ role: "franchise_managed", label: "Franczyza-obsługiwana", subGroupByPharmacy: true },
	{ role: "franchise_other", label: "Franczyza — inne", subGroupByPharmacy: false },
	{ role: "server", label: "Serwery", subGroupByPharmacy: false },
	{ role: "office_laptop", label: "Laptopy biurowe", subGroupByPharmacy: false },
	{ role: "natubay", label: "Natubay", subGroupByPharmacy: false },
	{ role: "it_admin", label: "IT / administratorzy", subGroupByPharmacy: false },
];
